import * as Yup from "yup";

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues
    image.src = url;
  });

export default async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("No 2d context");
  }

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      if (file) {
        resolve(file);
      } else {
        reject(new Error("Canvas is empty"));
      }
    }, "image/jpeg");
  });
}

export const createFileValidationSchema = (acceptedFileTypes,maxfileSize) => {
    const acceptedExtensions = acceptedFileTypes
        .split(',')
        .map((type) => type.trim().replace('.', ''))
        .filter((type) => !type.includes('*')); // exclude image wildcard
    
    return Yup.mixed()
        .test('fileType', 'Unsupported file format', (value) => {
            if (!value) return true; // no file selected
            const fileExtension = value.name.split('.').pop(); // this fixes the error
            return acceptedExtensions.includes(fileExtension || '');
        })
        .test('fileSize',  `File size must be less than ${maxfileSize}MB`, (value) => {
            if (value===undefined) return true;
            return value && value.size <= (maxfileSize) * 1024 * 1024; // limit file size to 5MB
        });
};
